import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router SPA tidak reset scroll position secara default saat
 * navigasi antar halaman. Komponen ini dipasang sekali di root App,
 * scroll ke atas otomatis tiap kali pathname berubah.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);

  return null;
}
